import { render } from "./VideoPlay.vue?vue&type=template&id=e8b1177a&scoped=true"
import script from "./VideoPlay.vue?vue&type=script&lang=js"
export * from "./VideoPlay.vue?vue&type=script&lang=js"

import "./VideoPlay.vue?vue&type=style&index=0&id=e8b1177a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8b1177a"]])

export default __exports__